import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BypassSecurityPipe } from '../../pipes/bypass-security.pipe';

@Component({
  selector: 'app-pdf-download-list',
  standalone: true,
  imports: [CommonModule, BypassSecurityPipe],
  templateUrl: './pdf-download-list.component.html',
  styleUrls: ['./pdf-download-list.component.less']
})
export class PdfDownloadListComponent {
  @Input() data: any;

  downloadPdf(url: string, filename: string): void {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || 'document.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  getFileSize(url: string): string {
    // This would typically be provided by the backend
    // For now, returning a placeholder
    return 'PDF';
  }
}